import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import BasePracticeScenario from "../../../../base-practice-scenario/BasePracticeScenario";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import GeneralProceduresBvmMain, { GeneralProceduresBvmMainConfig, GeneralProceduresBvmPart2Config } from "../GeneralProceduresBvmMain";

var bvmAttempts = 0;

export default class GeneralProceduresBvmPart2 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresBvmPart2Config {
		return this.scenarioConfig.part2Config;
	}
	constructor(private main: GeneralProceduresBvmMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresBvmMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.main.loopVideo(this, this.scenarioConfig.part1Config.chooseHandVideoChapter())
		this.step1ShowAIndicatorScreen();
	}

	public step1ShowAIndicatorScreen() {
		const context = this;
		var onDoneWithPopup = context._scenario.doSomething('Applying BVM...');
		setTimeout(() => {
			onDoneWithPopup();
			context.step2PlayFeedback();
		}, constants.doSomethingTimeout);
	}

	public step2PlayFeedback() {
		const context = this;
		bvmAttempts++; 
		if(context.config.onProcedureAttempted) {
			context.config.onProcedureAttempted(bvmAttempts);
		}
		if(bvmAttempts > 4) {
			bvmAttempts = 4;
		}

		if(bvmAttempts === 4) {
			if(context.config.onProcedureAttemptedMoreThan3Times) {
				context.config.onProcedureAttemptedMoreThan3Times();
			}
			// this._scenario.debriefLogFailedItem('You have attempted BVM more than 3');
		}

		var propName = 'BVMattempt';
		// switch(context.successType) {
		// 	case SuccessType.Failed:
		// 		propName += 'Failed';
		// 		break;
		// 	default:
		// 		propName += 'TempSuccess';
		// 		break;
		// }

		propName += bvmAttempts;
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>Squeezing Ambubag</p>`,
			onDismissed: () => {
				context.step4MovingAir();
			}
		})

		if(context.scenarioConfig.isAttemptSuccessful()) {
			(context.scenario as BasePracticeScenario).stopApneaTimerForEntireRunThrough();
		} else if(context.scenarioConfig.isTempSuccess()) {
			(context.scenario as BasePracticeScenario).resetApneaTimerForEntire();
		}

		var nonDefaultAudio = (this.config as any)['attempt' + bvmAttempts + 'AudioPath']
		context.scenario.auscultateAudio = nonDefaultAudio ?? './assets/audio/bvm/' + propName +'.mp3'
		// context.scenario.gameManager.SoundManager.playSound({
		// 	src: nonDefaultAudio ?? './assets/audio/bvm/' + propName +'.mp3',
		// 	autoPlay: true,
		// 	enableClosedCaptioning: false,
		// 	onEnded: () => {
		// 		context.step4MovingAir();
		// 	},
		// 	muted: false,
		// 	volume: 1
		// });
		

		// context.playVideoChapter((context._videoChapters as any)[propName], () => {
		// 	context.step3DisplayNotification();
		// })
	}

	public step4MovingAir() {
		const context = this;
		const isSuccessful = this.scenarioConfig.isAttemptSuccessful() || this.scenarioConfig.isTempSuccess();
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>${ isSuccessful ? 'Moving Air' : 'We\'re encountering some resistance.'}</p>`,
			onDismissed: () => {
			}
		})

		if(isSuccessful) {
			context.scenario.gameManager.SoundManager.playSound({
				src: './assets/audio/bvm/BVMmovingair.mp3',
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
		}
		
		context.onDone();
		// context.playVideoChapter(context._videoChapters.step4RTMovingAir, () => {
		// 	context.onDone();
		// })
	}
}